<template>
  <div class="department">
    <DpplDarkTooltip
      tooltip-placement="left"
      :tooltip-offset="12"
      light-mode
    >
      <template #activator="{ onMouseenter, onMouseleave }">
        <p
          @mouseenter="onMouseenter"
          @mouseleave="onMouseleave"
        >
          {{ departmentName }}
        </p>
      </template>
      <template #tooltip-content>
        <p class="content">
          {{ departmentName }}
        </p>
      </template>
    </DpplDarkTooltip>
  </div>
</template>

<script setup>
import DpplDarkTooltip from '@/components/datapeople/DpplDarkTooltip.vue';

defineProps({
  departmentName: {
    type: String,
    default: '',
  },
});
</script>

<style lang="less" scoped>
.department {
  max-width: 100%;

  :deep(p) {
    font-size: 13px;
    font-weight: 500;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    &.content {
      line-height: 150%;
      color: @text-light;
      overflow: visible;
      white-space: normal;
    }
  }
}
</style>
